export const itemInWorkspace = (workspace, item) => {
  return workspace.find(workspaceItem => {
    return (
      workspaceItem.model === item.model &&
      workspaceItem.foreignKey === item.foreignKey &&
      workspaceItem.PlacementId === item.PlacementId
    );
  });
};
